import $ from 'jquery';
import { SCENE_EVENTS } from '../../MVC/Model';
import { SCENE_INTERACTION } from '../../../constants/scene';

class JoinScene {

  constructor({ model }) {
    this.model = model;
    this.opened = false;

    this.template = $("#invite_user_to_scene");
    this.btnOk = $("#invite_user_to_scene #join-scene");
    this.btnCancel = this.template.find("#cancel-join-scene");
    this.socketUserWhoInvites = null;

    const onInvite = (e) => {
      this.close();
      const { receiverId, wantedSceneId, senderId, currentSceneId, currentSceneName } = e.payload;
      this.socketUserWhoInvites = this.model.socket.getAllOnlineUsersObject()[senderId]
      if (!this.socketUserWhoInvites) {
        this.model.alert('error', 'User not found');
        return;
      }
      this.socketUserWhoInvites.wantedSceneId = wantedSceneId || currentSceneId;
      const id = this.socketUserWhoInvites.wantedSceneId;
      let sceneName = "";
      if (this.model.scenes[id]) {
        sceneName = this.model.getSceneNameFromId(id);
      } else {
        sceneName = this.socketUserWhoInvites.currentSceneName;
        this.socketUserWhoInvites.callback = () => {
          window.location = `${window.location.protocol}//${window.location.host}/worlds/view?id=${this.socketUserWhoInvites.worldId}&security=${this.model.config.security}&loc=${this.socketUserWhoInvites.currentSceneId}`;
        }

      }
      const userName = this.socketUserWhoInvites.userName;
      const userAvatarUrl = this.socketUserWhoInvites.userAvatarUrl;
      this.open();
      this.template.find(".round-wrapper p").html(`${userName} <span data-lang="invitation-message">${$trans('invitation-message')}</span> ${sceneName}`);
      this.template.find(".local-avatar").attr("src", userAvatarUrl);
      // this.btnOk.on("click",)
    }

    this.model.addEventListener(SCENE_EVENTS.USER_JOIN_ROOM_INVITATAION, onInvite)
    this.btnCancel.on("click", () => {
      this.close();
    })
    this.btnOk.on("click", () => {
      this.close();
      if (this.socketUserWhoInvites.callback) {
        this.socketUserWhoInvites.callback();
      }
      this.model.dispatchEvent({
        type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
          sceneId: this.socketUserWhoInvites.wantedSceneId
        }
      });
    })

    this.open = (socketUser) => {
      this.template.addClass("is-active");
    }
    this.close = () => {
      this.template.removeClass("is-active");
    }
  }

}

export default JoinScene;
